export function formatHeat(heat: number): string {
  if (heat >= 10000) return `${(heat / 10000).toFixed(1)}万`;
  return String(heat);
}

export function rankTone(rank: number): string {
  if (rank === 1) return "bg-primary-500 text-background-50";
  if (rank === 2) return "bg-accent-500 text-accent-950";
  if (rank === 3) return "bg-secondary-500 text-background-50";
  return "bg-background-200 text-foreground-700";
}